import {Pipe, PipeTransform} from '@angular/core';
import {SalaryType} from '../enum/salary-type';

@Pipe({
  name: 'salaryType',
})
export class SalaryTypePipe implements PipeTransform {

  transform(value: SalaryType | undefined): string {
    switch (value) {
      case SalaryType.VOLUNTEER_UNPAID:
        return "Vrijwilliger zonder vergoeding";
      case SalaryType.PAID:
        return "Betaald";
      case SalaryType.UNPAID:
        return "Onbetaald";
      case SalaryType.VOLUNTEER_PAID:
        return "Vrijwilliger met vergoeding";
      default:
        return value || 'onbekend';
    }
  }

}
